import { Theme } from '@mui/material';

// NOTE: this override targets the Radio's two internal SVG layers by position
// (:nth-of-type) rather than by `[data-testid="RadioButton*Icon"]`. MUI 7 only
// emits those data-testid attributes in development
// (createSvgIcon.js: `process.env.NODE_ENV !== 'production' ? ... : undefined`),
// so the old data-testid selectors silently stopped matching in production
// builds and the custom radio color was lost. MUI renders the layers in a fixed
// order — 1st = unchecked background outline, 2nd = checked inner dot — so the
// selectors below reproduce the exact main-muvi appearance in production too.
const Radio = (theme: Theme) => {
  return {
    MuiRadio: {
      styleOverrides: {
        root: {
          marginInline: 2,
          '&.Mui-checked': {
            color: 'white',
          },
          // 2nd SVG = checked inner dot (was [data-testid="RadioButtonCheckedIcon"])
          '& .MuiSvgIcon-root:nth-of-type(2)': {
            borderRadius: '50%',
            border: `6px solid ${theme.palette.primary.main}`,
            backgroundColor: 'white',
          },
          // 1st SVG = unchecked background (was [data-testid="RadioButtonUncheckedIcon"])
          '& .MuiSvgIcon-root:nth-of-type(1)': {
            color: theme.palette.grey[30],
          },
          '&.custom-secondary': {
            '&.Mui-checked': {
              color: theme.palette.primary.main,
            },
            '& .MuiSvgIcon-root:nth-of-type(2)': {
              borderRadius: '50%',
              border: `6px solid white`,
              backgroundColor: theme.palette.primary.main,
            },
            '& .MuiSvgIcon-root:nth-of-type(1)': {
              color: 'white',
            },
          },
        },
      },
    },
  };
};
export default Radio;
